import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';
import Hint from 'src/ui/atoms/hint';

interface DeleteMarketPricesSuccessModalProps {
  onClose: () => void;
}

const DeleteMarketPricesSuccessModal: FunctionComponent<DeleteMarketPricesSuccessModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="marketPrices.marketPriceDeletedTitle" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="marketPrices.marketPriceDeleted" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: () => onClose(),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteMarketPricesSuccessModal;
